/** 管理路由 */
import Layout from '@/views/layout/contractLayout'

const Router = {
	path: '/contract',
	component: Layout,
	redirect: '/contract/index',
	name: 'contract',
	hidden: true,
	meta: {
		requiresAuth: true,
		title: '顾问单位',
		index: 0,
		type: 'contract'
	},
	children: [
		{
			path: 'index', 
			component: () => import('@/views/contract/index'),
			meta: {
				requiresAuth: true,
				title: '顾问单位',
				icon: 'user',
				index: 1,
				type: 'contract',
				subType: 'index'
			}
		},
		{
			path: 'servicelogindex', 
			component: () => import('@/views/contract/servicelog'),
			meta: {
				requiresAuth: true,
				title: '服务日志',
				icon: 'log',
				index: 1,
				type: 'contract',
				subType: 'servicelogindex'
			}
		},
		{
			path: 'contractcomplainindex', 
			component: () => import('@/views/contract/complain'),
			meta: {
				requiresAuth: true,
				title: '客户反馈',
				icon: 'log',
				index: 1,
				type: 'contract',
				subType: 'contractcomplainindex'
			}
		},
		{
			path: 'statistics', 
			component: () => import('@/views/contract/statistics'),
			meta: {
				requiresAuth: true,
				title: '统计',
				icon: 'relevance',
				index: 1,
				type: 'contract',
				subType: 'statistics'
			}
		},
		{
			path: 'read/:tabname/:id', 
			hidden:true,
			component: () => import('@/views/contract/read'),
			meta: {
				requiresAuth: true,
				title: '详情',
				index: 1,
				type: 'contract',
				subType: 'read'
			}
		}
  ]
}

export default Router

export const managerRouterMenu = [
	...Router.children
]